function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#kremlinview_svg__clip0_1_48)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.565 10.399a.647.647 0 01-.374-.12.615.615 0 01-.254-.607l.477-2.708L.396 5.046a.611.611 0 01-.161-.638.634.634 0 01.515-.423l2.788-.395 1.247-2.464c.215-.424.929-.424 1.143 0L7.175 3.59l2.788.395c.24.034.439.198.515.423a.611.611 0 01-.161.638L8.298 6.964l.477 2.708a.616.616 0 01-.253.608.65.65 0 01-.671.047L5.355 9.05l-2.493 1.278a.65.65 0 01-.297.072zm.78-4.034a.681.681 0 01.203.61l-.35 1.985 1.828-.937a.724.724 0 01.658 0l1.828.937-.35-1.985a.68.68 0 01.203-.61l1.48-1.406L6.8 4.67a.706.706 0 01-.532-.377l-.914-1.807-.914 1.806a.706.706 0 01-.532.377l-2.043.29 1.478 1.406zm5.893 9.442l-2.457-1.155a.618.618 0 01-.09-.172l-1.363-3.2-1.365 3.2a.594.594 0 01-.089.172l-2.458 1.156-1.241-.197c0-.128.041-.252.118-.356l2.518-1.236 1.925-3.703a.62.62 0 01.592-.422c.27 0 .509.17.59.422l1.926 3.703 2.517 1.236a.596.596 0 01.119.356l-1.242.196z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "kremlinview_svg__clip0_1_48"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h11v16H0z"
})));

function SvgKremlinview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgKremlinview;